import React from 'react';

import Carousel from '../../../components/Carousel.jsx';
import ImagePlusText from '../../modules/ImagePlusText.jsx';
import ProductSlugFacade from '../../modules/products/ProductSlugFacade.jsx';
import HtmlText from '../../modules/HtmlText.jsx';
import Gallery from '../../modules/Gallery.jsx';
import PromoImages from '../../modules/promo/PromoImages.jsx';
import TopBrands from '../../modules/brands/TopBrands.jsx';
import Video from '../../modules/Video.jsx';
import VideoVimeo from '../../modules/VideoVimeo.jsx';
import VideoEmbed from '../../modules/VideoEmbed.jsx';
import TopBlogPosts from '../../modules/blogposts/TopBlogPosts.jsx';
import GridProducts from '../../modules/GridProducts.jsx';
import ButtonGroup from '../../modules/ButtonGroup.jsx';
import HidingItems from '../../modules/HidingItems.jsx';
import CmsModules from '../../../services/cms/CmsModules';

import './HomePageBase.scss';

const HomePageBase = ({ content }) => {
    return (
        <>
            <div className='home-dynamic-base'>
                {content.map((c, idx) => {
                    if (c.__typename === CmsModules.Banners) {
                        return <Carousel key={idx} banners={c.banners} />;
                    } else if (c.__typename === CmsModules.ProductGallery) {
                        return (
                            <ProductSlugFacade
                                key={idx}
                                products={c.products}
                            />
                        );
                    } else if (c.__typename === CmsModules.HidingItems) {
                        return <HidingItems key={idx} elements={c.elements} />;
                    } else if (c.__typename === CmsModules.ImagePlusText) {
                        return (
                            <ImagePlusText
                                key={idx}
                                orientation={c.orientation}
                                url={c.image.data.attributes.url}
                                width={c.image.data.attributes.width}
                                height={c.image.data.attributes.height}
                                text={c.text}
                                imageUrl={c.imageUrl}
                                caption={c.imageCaption}
                            />
                        );
                    } else if (c.__typename === CmsModules.HtmlText) {
                        return <HtmlText content={c.htmlText} key={idx} />;
                    } else if (c.__typename === CmsModules.Gallery) {
                        return <Gallery key={idx} imagesArray={c.images} />;
                    } else if (c.__typename === CmsModules.TopBrands) {
                        return <TopBrands key={idx} brands={c.brands} />;
                    } else if (c.__typename === CmsModules.PromoImages) {
                        return (
                            <PromoImages
                                key={idx}
                                promoImages={c.promoImages.promoImages}
                            />
                        );
                    } else if (c.__typename === CmsModules.Video) {
                        return (
                            <Video
                                key={idx}
                                video={c.video}
                                isBanner={c.isBanner}
                            />
                        );
                    } else if (c.__typename === CmsModules.VideoVimeo) {
                        return (
                            <VideoVimeo
                                key={idx}
                                idvideo={c.idvideo}
                                overlayText={c.overlayText}
                                position={c.position}
                            />
                        );
                    } else if (c.__typename === CmsModules.VideoEmbed) {
                        return (
                            <VideoEmbed
                                key={idx}
                                externalVideoEmbed={c.externalVideoEmbed}
                            />
                        );
                    } else if (c.__typename === CmsModules.TopBlogPosts) {
                        return (
                            <TopBlogPosts
                                key={idx}
                                blogposts={c.items.data}
                                showInCarousel={c.showInCarousel}
                            />
                        );
                    } else if (
                        c.__typename === CmsModules.LatestArrivals ||
                        c.__typename === CmsModules.Offers ||
                        c.__typename === CmsModules.Category
                    ) {
                        return (
                            <GridProducts
                                key={idx}
                                component={c.__typename}
                                showButtonAndTitle={c.showButtonAndTitle}
                                slug={c.categorySlug}
                                numberOfProducts={c.numberOfProducts}
                            />
                        );
                    } else if (c.__typename === CmsModules.ButtonGroup) {
                        return (
                            <ButtonGroup
                                key={idx}
                                buttonsList={c.buttonsList}
                                orientation={
                                    c.orientationComponentRepeatableComponentsButtonGroup
                                }
                                alignment={c.alignment}
                            />
                        );
                    } else if (c.__typename === CmsModules.Button) {
                        return (
                            <ButtonGroup
                                key={idx}
                                buttons={[c]}
                                orientation='row'
                                alignment='center'
                            />
                        );
                    } else {
                        return (
                            <p key={idx} style={{ display: 'none' }}>
                                {console.error(
                                    `Component ${c.__typename} missing`
                                )}
                            </p>
                        );
                    }
                })}
            </div>
        </>
    );
};

export default HomePageBase;
